import React from 'react';
import {Control, ErrorComponent} from 'MWC';

export default function template() {
    return (
        <div className="module-home-error">
            <Control className="control">
                <ErrorComponent type="form" className="blue">
                    {this.l10n('ABOUT_REPORTS_ERROR_TEXT')}
                </ErrorComponent>
            </Control>
        </div>
    );
}
